// extracted by mini-css-extract-plugin
module.exports = {"primary-button":"Button-module--primary-button--3Swbx","primary-button--secondary":"Button-module--primary-button--secondary--1xs5h"};